/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { ValidateEarlyAccessResponse, ValidateEarlyAccessVars } from '../openapi-types.gen.js';

export type { ValidateEarlyAccessResponse, ValidateEarlyAccessVars } from '../openapi-types.gen.js';

export const useValidateEarlyAccess = createMutationHook<ValidateEarlyAccessVars, ValidateEarlyAccessResponse, unknown>({
  specName: 'useValidateEarlyAccess',
  path: '/v1/early-access/validate',
  method: 'POST',
  resolveUrl: (vars: ValidateEarlyAccessVars) => `/v1/early-access/validate`,
  buildBody: (vars: ValidateEarlyAccessVars) => ({ code: vars.code, ref: vars.ref }),
  parseResponse: (raw: unknown): ValidateEarlyAccessResponse => raw as ValidateEarlyAccessResponse,
  
  
  
});
